export const baseUrl = "http://localhost:8081"; //OLD
export const BASEURL2 = process.env.REACT_APP_API_ENDPOINT + '/api';
// export const BASEURL2 = process.env.REACT_APP_API_ENDPOINT;
export const HEADERS = {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'Connection': 'close',
    // 'Access-Control-Allow-Origin': "omit"
    // 'Access-Control-Allow-Origin': '*'
    'Access-Control-Allow-Origin': 'consignments.fmpco.com'

}

export const HEADERS_JSON = {
    'Content-Type': 'application/json'
    // 'Connection': 'close',
    // 'Access-Control-Allow-Origin': "omit"
    // 'Access-Control-Allow-Origin': '*'
}

//TESTING PURPOSES
export const increment = nr => {
    return {
        type: 'INCREMENT',
        payload: nr
    };
};

//TESTING PURPOSES
export const decrement = () => {
    return {
        type: 'DECREMENT'
    }
}

//TESTING PURPOSES
export const signed_in = () => {
    return {
        type: 'SIGNED_IN'
    }
}